export default __webpack_public_path__ + "static/media/property_615.c78d177e.png";